import { render, staticRenderFns } from "./TblEventFault.vue?vue&type=template&id=643f5eba"
import script from "./TblEventFault.vue?vue&type=script&lang=js"
export * from "./TblEventFault.vue?vue&type=script&lang=js"
import style0 from "./TblEventFault.vue?vue&type=style&index=0&id=643f5eba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports